import ArrowDownward from "@mui/icons-material/ArrowDownward";
import { Box, Collapse, Divider, Typography } from "@mui/material";
import type { FC, MouseEvent } from "react";
import { FONT_SIZE, NEUTRAL } from "../../../../theme/tokens";
import type { Recommendation } from "../../../../utils/models";
import { RecommendationsColor } from "../../../Recommendations/RecommendationColor";
import { RecommendationsSubTitle } from "../../../Recommendations/Utils/RecommendationsUtils";

interface IProps {
	recommendations: Recommendation[];
	isRecommendationsExpanded: boolean;
	onExpandRecommendations: (event: MouseEvent) => void;
	onApprove: (recommendation: Recommendation) => void;
}

export const DayRecommendations: FC<IProps> = ({ recommendations, onExpandRecommendations, isRecommendationsExpanded, onApprove }) => {
	return (
		<>
			{recommendations.length > 0 ? (
				<Box
					sx={{
						cursor: "pointer",
						"&:hover": {
							bgcolor: NEUTRAL[50],
						},
						transition: "background-color 0.2s ease",
						px: 1,
						borderRadius: "4px",
					}}
				>
					{recommendations.slice(0, 1).map((recommendation) => (
						<Box
							key={recommendation.severity}
							sx={{
								height: "28px",
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
							}}
						>
							<Box onClick={() => onApprove(recommendation)} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
								<RecommendationsColor severity={recommendation.severity} />
								<Typography sx={{ fontWeight: 400, fontSize: FONT_SIZE.EMPHASIS, color: "primary.dark" }}>
									{RecommendationsSubTitle[recommendation.type]}
								</Typography>
							</Box>
							{recommendations.length > 1 && (
								<ArrowDownward
									onClick={onExpandRecommendations}
									className="arrow-icon"
									sx={{
										color: "primary.main",
										transform: isRecommendationsExpanded ? "rotate(180deg)" : "rotate(0deg)",
										transition: "transform 0.3s ease, opacity 0.2s ease",
										fontSize: 16,
									}}
								/>
							)}
						</Box>
					))}
					<Collapse in={isRecommendationsExpanded}>
						{recommendations.slice(1).map((recommendation, index) => (
							<Box key={`${recommendation.id}-${index}`} sx={{ height: "28px" }}>
								<Divider />
								<Box onClick={() => onApprove(recommendation)} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
									<RecommendationsColor severity={recommendation.severity} />
									<Typography sx={{ fontWeight: 400, fontSize: FONT_SIZE.EMPHASIS, color: "primary.dark" }}>
										{RecommendationsSubTitle[recommendation.type]}
									</Typography>
								</Box>
							</Box>
						))}
					</Collapse>
				</Box>
			) : (
				<Box
					sx={{
						cursor: "pointer",
						height: "28px",
						"&:hover": {
							bgcolor: NEUTRAL[50],
						},
						transition: "background-color 0.2s ease",
						px: 1,
						borderRadius: "4px",
					}}
				>
					<Typography sx={{ fontWeight: 400, fontSize: FONT_SIZE.EMPHASIS, color: "primary.dark" }}>--</Typography>
				</Box>
			)}
		</>
	);
};
